import { Accordion, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const Producer = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel11-content"
                id="panel11-header"
            >
                Multi-brand vs single-brand producer
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    Example 1 - <Styled.Bold>One Account Required</Styled.Bold>: A winemaker
                    (company) possesses a single brand named “Brand 1”, either with a different name
                    or identical to the company itself. This approach allows them to indicate that
                    the brand is affiliated with their company, which shares the same name.
                </Typography>
                <Typography variant="body2">
                    Example 2 -{" "}
                    <Styled.Bold>Two Accounts Required (Multi-brand Producers)</Styled.Bold>: A
                    winemaker introduces a new line of wines named "Brand 2" targeting a younger
                    clients. Given that these wines are produced by the same company and at the same
                    location as the initial brand named "Brand 1" the producer now associates their
                    company with two distinct brands. To manage these brands effectively, it is
                    necessary to register two separate brand accounts within the same company
                    profile.
                </Typography>
                <Typography variant="body2">
                    A multi-brand account serves as a collective platform for all your brands,
                    allowing you to manage and share all your products centrally. Each individual
                    brand maintains its dedicated profile and these profiles can represent various
                    types.
                </Typography>
                <Styled.Heading>
                    How does a Multi-Brand Producer facilitate information exchange?
                </Styled.Heading>
                <Typography variant="body2">
                    The Multi-Brand Producer account oversees the entire wine portfolio as a master
                    repository. These distinct brand profiles operate independently and are under
                    your control, allowing them to share product information as needed.
                </Typography>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default Producer;
